import { render, staticRenderFns } from "./SalesSubheader.vue?vue&type=template&id=4e198a80&scoped=true&lang=html&"
import script from "./SalesSubheader.vue?vue&type=script&lang=js&"
export * from "./SalesSubheader.vue?vue&type=script&lang=js&"
import style0 from "./SalesSubheader.vue?vue&type=style&index=0&id=4e198a80&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e198a80",
  null
  
)

export default component.exports